import React, { useState, useEffect } from 'react';
import { PLAYER } from '../data';
import { SHOP_ITEMS } from '../content/shop';

function Shop({ app }) {
  const [currency, setCurrency] = useState(PLAYER.resources);
  const [powerups, setPowerups] = useState(PLAYER.powerups);
  const [purchasing, setPurchasing] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrency({ ...PLAYER.resources });
      setPowerups({ ...PLAYER.powerups });
    }, 10);

    return () => clearInterval(interval);
  }, []);

  const handlePurchase = (type) => {
    if (PLAYER.resources.currency >= SHOP_ITEMS.powerups[type].cost) {
      setPurchasing(prev => ({ ...prev, [type]: true }));
      
      setTimeout(() => {
        PLAYER.resources.currency -= SHOP_ITEMS.powerups[type].cost;
        PLAYER.powerups[type]++;
        setPurchasing(prev => ({ ...prev, [type]: false }));
      }, 500);
    }
  };

  const handleBundlePurchase = (bundleId) => {
    const bundle = SHOP_ITEMS.bundles[bundleId];
    if (PLAYER.resources.currency >= bundle.cost) {
      setPurchasing(prev => ({ ...prev, [bundleId]: true }));

      setTimeout(() => {
        PLAYER.resources.currency -= bundle.cost;
        Object.entries(bundle.contents).forEach(([type, amount]) => {
          PLAYER.powerups[type] += amount;
        });
        setPurchasing(prev => ({ ...prev, [bundleId]: false }));
      }, 500);
    }
  };

  const renderPowerupButton = (type) => {
    const item = SHOP_ITEMS.powerups[type];
    const count = powerups[type];
    const canAfford = currency.currency >= item.cost;
    const isPurchasing = purchasing[type];

    return (
      <div 
        key={type} 
        className={`flex items-center justify-between bg-gray-800 p-4 rounded-lg transition-all duration-200 ${
          isPurchasing ? 'scale-105 bg-gray-700' : ''
        }`}
      >
        <div>
          <h3 className="text-lg font-bold capitalize">{item.name}</h3>
          <p className="text-sm text-gray-300">Owned: {count}</p>
          <p className="text-xs text-gray-400">{item.description}</p>
        </div>
        <button
          onClick={() => handlePurchase(type)}
          disabled={!canAfford || isPurchasing}
          className={`px-4 py-2 rounded-lg font-bold transition-all duration-200 ${
            canAfford && !isPurchasing
              ? 'bg-yellow-400 hover:bg-yellow-500 cursor-pointer'
              : 'bg-gray-600 cursor-not-allowed'
          }`}
        >
          {isPurchasing ? 'Buying...' : `${item.cost} Coins`}
        </button>
      </div>
    );
  };

  const renderBundleButton = (bundleId) => {
    const bundle = SHOP_ITEMS.bundles[bundleId];
    const canAfford = currency.currency >= bundle.cost;
    const isPurchasing = purchasing[bundleId];

    return (
      <div 
        key={bundleId} 
        className={`flex items-center justify-between bg-gray-700 p-4 rounded-lg transition-all duration-200 ${
          isPurchasing ? 'scale-105 bg-gray-600' : ''
        }`}
      >
        <div>
          <h3 className="text-lg font-bold">{bundle.name}</h3>
          <p className="text-sm text-gray-300">{bundle.description}</p>
          <div className="text-xs text-gray-400">
            {Object.entries(bundle.contents).map(([type, amount]) => (
              <span key={type} className="mr-2">
                {SHOP_ITEMS.powerups[type].name}: {amount}
              </span>
            ))}
          </div>
          <p className="text-sm text-green-400 font-bold">{bundle.savings}</p>
        </div>
        <button
          onClick={() => handleBundlePurchase(bundleId)}
          disabled={!canAfford || isPurchasing}
          className={`px-4 py-2 rounded-lg font-bold transition-all duration-200 ${
            canAfford && !isPurchasing
              ? 'bg-yellow-400 hover:bg-yellow-500 cursor-pointer'
              : 'bg-gray-600 cursor-not-allowed'
          }`}
        >
          {isPurchasing ? 'Buying...' : `${bundle.cost} Coins`}
        </button>
      </div>
    );
  };

  return (
    <div className="h-full w-full flex flex-col items-center bg-gray-900 p-8 overflow-auto">
      <div className="w-full max-w-md space-y-4">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-white mb-2">Power-up Shop</h2>
          <p className="text-gray-300">Coins: {currency.currency}</p>
        </div>
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-white">Bundles</h3>
          {Object.keys(SHOP_ITEMS.bundles).map(bundleId => renderBundleButton(bundleId))}
        </div>
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-white">Individual Items</h3>
          {Object.keys(SHOP_ITEMS.powerups).map(type => renderPowerupButton(type))}
        </div>
      </div>
    </div>
  );
}

export default Shop;
